import { queryOptions, useQuery } from "@tanstack/react-query";

import type { QueryConfig } from "@/lib/react-query";
import { apiPaths } from "@/config/paths";
import type { AccountInfo } from "@blueskydataplatform/shared-ui/types/account.types";
import { env } from "@blueskydataplatform/shared-ui/config/env";
import { authApiWithAuth } from "@blueskydataplatform/shared-ui/lib/api-client";

const getAccountInfo = (): Promise<{
  data: AccountInfo;
}> => {
  // /account
  return authApiWithAuth.get(apiPaths.account.getAccountInfo.getPath(), {
    baseURL: env.API_URL_V2,
  });
};

const getAccountInfoQueryOptions = () => {
  return queryOptions({
    queryKey: ["subscriptions", "account-info"],
    queryFn: () => getAccountInfo(),
    select: data => data.data,
  });
};

type UseDatasetOptions = {
  queryConfig?: QueryConfig<typeof getAccountInfoQueryOptions>;
};

export const useAccountInfo = ({ queryConfig }: UseDatasetOptions = {}) => {
  return useQuery({
    ...getAccountInfoQueryOptions(),
    ...queryConfig,
  });
};
